module.exports = __webpack_public_path__ + "img/approved.cc426525.png";